import { useState } from "react";
import { useFullCircleExport } from "./useFullCircleExport";
import FullCircleFilterList, { FullCircleFilterObject } from "./FullCircleFilterList";
import ExportAllLeadsModal from "../../../../../../mogul/modals/ExportAllLeadsModal";
import FilterListButton from "../shared/FilterListButton";

export default function FullCircleTableHeader({
    title,
    subtitle = '',
    filterLocalStorageKey,
    currentFilter,
    onApplyFilter,
    searchBar,
    personSearchFilter
}: {
    title: string;
    subtitle?: string;
    filterLocalStorageKey: string;
    currentFilter: FullCircleFilterObject | null;
    onApplyFilter: (filterObject: FullCircleFilterObject) => void;
    searchBar?: React.ReactNode;
    personSearchFilter?: string;
}) {

    const [viewingFilter, setViewingFilter] = useState(false)

    const {
        exporting,
        errorExporting,
        onExportLeadListToCSV
    } = useFullCircleExport()

    return <>
        {/* begin::Header */}
        <div className='card-header align-items-center border-0 mt-3'>
            <div className='d-flex align-items-center w-100'>
                <h3 className='card-title align-items-start flex-column me-auto'>
                    <span className='fw-bolder text-dark fs-3'>
                        {title}
                    </span>
                    {subtitle && <span className='text-gray-400 mt-2 fw-bold fs-6'>{subtitle}</span>}
                </h3>
                {searchBar && (
                    <div className='me-3'>
                        {searchBar}
                    </div>
                )}
                <div className='card-toolbar'>
                <button
                    className='btn btn-sm btn-light me-2'
                    data-bs-toggle='modal'
                    data-bs-target='#modal_export_all_leads'
                >
                    <span className='d-none d-md-inline'>
                        Export
                    </span>
                </button>
                <ExportAllLeadsModal
                    filterChild={<FullCircleFilterList
                        isFilterChild
                        onReset={() => {
                        }}
                        onCancel={() => { }}
                        currentFilterObject={currentFilter}
                        onApplyFilter={() => { }}
                    />}
                    exporting={exporting}
                    errorExporting={errorExporting}
                    onExport={() => {
                        if (currentFilter) {
                            onExportLeadListToCSV(currentFilter, personSearchFilter)
                        } else {
                            onExportLeadListToCSV({} as FullCircleFilterObject, personSearchFilter) // empty filter for all leads
                        }
                    }}
                    disableExportForReason={(currentFilter?.selectedOrgIds.length || 0) === 0 ? 'You need to select at least one organization to export leads.' : ''}
                />
                <FilterListButton
                    onClick={() => {
                        setViewingFilter(true)
                    }}
                    hasFiltersApplied={
                        (currentFilter?.selectedOrgIds.length || 0) > 0 ||
                        (currentFilter?.selectedPreneedOptions.length || 0) > 0 ||
                        !!currentFilter?.onlyUnSyncedWith360 ||
                        !!currentFilter?.includeLeadsRegardlessOfPreneedStatus ||
                        !!currentFilter?.startingUnixTimestamp ||
                        !!currentFilter?.endingUnixTimestamp
                    }
                />
                </div>
            </div>
        </div>
        {/* end::Header */}
        {viewingFilter && <>
            <FullCircleFilterList
                onReset={() => {
                    onApplyFilter({
                        selectedOrgIds: [],
                        selectedPreneedOptions: [],
                        onlyUnSyncedWith360: false,
                        includeLeadsRegardlessOfPreneedStatus: false,
                        startingUnixTimestamp: undefined,
                        endingUnixTimestamp: undefined
                    })
                    localStorage.removeItem(filterLocalStorageKey)
                }}
                onCancel={() => setViewingFilter(false)}
                currentFilterObject={currentFilter}
                onApplyFilter={(filterObject: FullCircleFilterObject) => {
                    onApplyFilter(filterObject)
                    setViewingFilter(false)
                    localStorage.setItem(filterLocalStorageKey, JSON.stringify(filterObject))
                }}
            />
        </>}
    </>

}